import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { ApplicationResponse } from '../dtos/ApplicationResponse';
import { PatchApplicationRequest } from '../dtos/PatchApplicationRequest';
import { ProductResponse } from '../dtos/ProductResponse';
import { DocumentType } from '../dtos/DocumentType';
import { UploadFileResponse } from '../dtos/UploadFileResponse';
import { SignApplicationRequest } from '../dtos/SignApplicationRequest';
import { ApplicationDetailResponse } from '../dtos/ApplicationDetailResponse';
import { AddressResponse } from '../dtos/AddressResonse';
import { FoundCustomer } from '../models/model/foundCustomer';
import { AddressModel } from '../models/generic-forms.model';
import { CountryModel, DocumentUploadResponse, FileUploadResponse } from '../models/common-api.model';
import { CustomerInfo } from '../models/application.model';
import { createUuid } from '../validators/CustomValidator';
import { InitApplicationRequest } from '../models/model/initApplicationRequest';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiConnectorService {
  private baseUrl: string = '';
  private addressEndpoint: string = environment.addressEndpoint;
  private baseAccountApi = environment.serviceFormApiUrl + '/craftsmen/gw/cams';
  // private addressApiUrl = environment.a + '/master-data/gw';  
   private countryCodes$: Observable<CountryModel[]> | any;
  sessionId: any;
    private documentApi = environment.serviceFormApiUrl + '/techops/gw/documents';

  constructor(private http: HttpClient) {
    // if (environment.name === 'local') {
    //   this.baseUrl = '/cc-onboarding/v1/b2b';
    // } else {
      this.baseUrl = environment.apiUrl;
      this.init();
       this.generateSessionId();
    // }
  }

   init() {
    this.countryCodes$ = this.http
      .get<CountryModel[]>('/assets/data/country_iso_code.json')
      .pipe(shareReplay(1));
  }

  initApplication(): Observable<ApplicationResponse> {
    let path: string = this.baseUrl + '/applications';

    return this.http.post<ApplicationResponse>(path, null);
  }

  getCountryCodes(): Observable<CountryModel[]> {
    return this.countryCodes$;
  }

  searchNewAddress(street: string): Observable<AddressModel[]> {
    return this.http.get<AddressModel[]>(
      `${this.addressEndpoint}/addresses?street=${encodeURIComponent(street)}`
    );
  }

  
  patchApplication(
    patchApplicationRequest: PatchApplicationRequest,
    applicationId: string
  ): Observable<any> {
    let path: string = this.baseUrl + '/applications/' + applicationId;

    return this.http.patch<any>(path, patchApplicationRequest);
  }

  getActiveProducts(
    birthday: string,
    occupation: string,
    income: number,
    industry: string,
    workingIncome: boolean
  ): Observable<ProductResponse[]> {
    let path: string =
      this.baseUrl +
      '/products?income=' +
      income +
      '&birthday=' +
      birthday +
      '&occupation=' +
      occupation +
      '&workingIncome=' +
      workingIncome;

    if (industry != null) {
      path = path + '&industry=' + industry;
    }

    return this.http.get<ProductResponse[]>(path);
  }

  uploadFile(
    applicationId: string,
    file: File,
    documentType: string
  ): Observable<UploadFileResponse> {
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentType);

    let path: string =
      this.baseUrl + '/applications/' + applicationId + '/documents';

    return this.http.post<UploadFileResponse>(path, formData);
  }

  confirmApplication(
    applicationId: string,
    primary: boolean
  ): Observable<ApplicationResponse> {
    let options = {};

    if (primary) {
      let headers = new HttpHeaders({
        primary: 'true',
      });
      options = { headers: headers };
    }
    let path: string =
      this.baseUrl + '/applications/' + applicationId + '/confirm';
    return this.http.post<ApplicationResponse>(path, null, options);
  }

  getContractPreview(applicationId: string): Observable<Blob> {
    let path: string =
      this.baseUrl + '/applications/' + applicationId + '/contract-preview';
    return this.http.get(path, { responseType: 'blob' });
  }

  signApplication(
    applicationId: string,
    signApplicationRequest: SignApplicationRequest,
    primary: boolean
  ): Observable<ApplicationResponse> {
    let options = {};

    if (primary) {
      let headers = new HttpHeaders({
        primary: 'true',
      });
      options = { headers: headers };
    }

    let path: string =
      this.baseUrl + '/applications/' + applicationId + '/sign';
    return this.http.post<ApplicationResponse>(
      path,
      signApplicationRequest,
      options
    );
  }

    generateSessionId() {
    this.sessionId = createUuid();
  }

    getApplicationId() {
    return this.sessionId;
  }


  getApplication(applicationId: string): Observable<ApplicationDetailResponse> {
    let path: string = this.baseUrl + '/applications/' + applicationId;
    return this.http.get<ApplicationDetailResponse>(path);
  }

  searchAddress(street: string): Observable<AddressResponse[]> {
    let path: string = this.addressEndpoint + '?street=' + street;
    return this.http.get<AddressResponse[]>(path);
  }

  uploadGuarantee(
    applicationId: string,
    file: File
  ): Observable<ApplicationResponse> {
    let formData: FormData = new FormData();
    formData.append('file', file);

    let path: string =
      this.baseUrl + '/applications/' + applicationId + '/afterward-guarantee';

    return this.http.post<ApplicationResponse>(path, formData);
  }



  // B2B service forms
  searchCustomers(
    isKundenName: boolean,
    body: CustomerInfo,
    entity?: string,
  ): Observable<FoundCustomer[]> {
    let requestOptions: Object = {};
    if (isKundenName && entity) {
      requestOptions = {
        headers: this.getHeaders(),
        params: new HttpParams()
          .set('firstName', body.firstName!!)
          .set('lastName', body.lastName!!)
          .set('birthDate', body.birthDate!!)
          .set('entity', entity)
      };
    } else if (isKundenName && !entity) {
      requestOptions = {
        headers: this.getHeaders(),
        params: new HttpParams()
          .set('firstName', body.firstName!!)
          .set('lastName', body.lastName!!)
          .set('birthDate', body.birthDate!!)
      };
    } 
    return this.http.get<FoundCustomer[]>(
      `${this.baseAccountApi}/bb/customer/search`,
      requestOptions
    );
  }

  
  updateCustomerAddressInfo(
    body: any,
    id: string
  ): Observable<any> {
    const requestOptions: Object = {
      headers: this.getHeaders(),
    };
    return this.http.patch<any>(
      `${this.baseAccountApi}/bb/customer` + '/' + id,
      body,
      requestOptions
    );
  }

  updateNewPhoneNumber(body: InitApplicationRequest) {
    const requestOptions: Object = {
      observe: 'response',
    };
    return this.http.post(
      `${this.baseAccountApi}/bb/applications`,
      body,
      requestOptions
    );
  }


  generateTanForNewPhoneNumber(sessionId: any) {
    const requestOptions: Object = {
      observe: 'response',
    };
    return this.http.post(
     `${this.baseAccountApi}/bb/application/${sessionId}/code`,
      null,
      requestOptions
    );
  }

    resendTan(sessionId: any) {
    const requestOptions: Object = {
      observe: 'response',
    };
    return this.http.post<any>(
      `${this.baseAccountApi}/bb/application/${sessionId}/code`,
      null,
      requestOptions
    );
  }


  verifyTanForNewPhoneNumber(body: any, sessionId: any) {
    const requestOptions: Object = {
      observe: 'response',
    };

    return this.http.post<any>(
      `${this.baseAccountApi}/bb/application/${sessionId}/verify`,
      body,
      requestOptions
    );
  }

  uploadDocuments(file: File, applicationId: any) {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<FileUploadResponse>(
      `${this.documentApi}` + `?sessionId=${applicationId}`,
      formData
    );
  }

  getUploadedDocuments(applicationId: any) {
    const requestOptions: Object = {};
    return this.http.get<DocumentUploadResponse>(
      `${this.documentApi}` + `?sessionId=${applicationId}`,
      requestOptions
    );
  }

  removeDocument(applicationId: string, docId: string) {
    const requestOptions: Object = {
      observe: 'response',
    };
    return this.http.delete(
      `${this.documentApi}/${docId}` + `?sessionId=${applicationId}`,
      requestOptions
    );
  }


   private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
    });
  }



}
